<template lang="pug">
  div.input-tags
    .flex-between-center
      el-input.input-new-tag(
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        :size="GLOBAL.SIZE_OF_INPUTBOX"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
        :disabled="disabled"
        )
      el-button.button-new-tag(
        v-else
        :disabled="disabled"
        :size="GLOBAL.SIZE_OF_INPUTBOX"
        @click="showInput") + New Tag
    .industry-label.flex.mt-20(v-if="!disabled")
      label.label 港股
      el-cascader.label-select.ml-10( :size="GLOBAL.SIZE_OF_INPUTBOX" :options="options" :props="industryProps" filterable v-model="industryValue" @change="addIndustry" :disabled="disabled" placeholder="请选择港股标签")
      label.label.box 板块
      el-cascader.label-select.ml-10( :size="GLOBAL.SIZE_OF_INPUTBOX" :options="plateLAbel" :props="industryProps" filterable v-model="industryValue" @change="addLabel" :disabled="disabled" placeholder="请选择板块标签")
    el-row
      el-tag(
        v-for="(tag, index) in tagData"
        :key="index"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)") {{tag}}

</template>

<script>
import Enum from '@/apis/enum'
function getCascaderObj (val, opt) {
  return val.map(function (value, index, array) {
    for (var itm of opt) {
      if (itm.id === value) {
        opt = itm.children
        return itm.name
      }
    }
    return null
  })
}
export default {
  props: {
    tagData: {
      props: Array,
      default: function () {
        return []
      }
    },
    disabled: { type: Boolean }
  },
  data () {
    return {
      inputVisible: true,
      inputValue: '',
      options: [],
      industryProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        expandTrigger: 'hover',
        checkStrictly: true
      },
      industryValue: [],
      plateLAbel: Enum.PLATE_LABEL
    }
  },
  created () {
    // console.log('getHKSharesIndustryCatelogue', Enum.INDUSTRY_LABEL)
    this.options = Enum.INDUSTRY_LABEL
  },
  methods: {
    // 删除tag
    handleClose (tag) {
      this.tagData.splice(this.tagData.indexOf(tag), 1)
    },
    // 新增tag 改变tag输入状态
    showInput () {
      // this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 确认input中的tag 并且提交数据
    handleInputConfirm () {
      const inputValue = this.inputValue
      if (inputValue.trim() !== '') {
        const res = inputValue.trim().split(/[ ]+/)
        res.map(item => {
          this.tagData.push(item)
        })
        this.$emit('getData', this.tagData)
      }
      // this.inputVisible = false
      this.inputValue = ''
    },
    addLabel (e) {
      const tags = this.tagData || []
      if (this.industryValue.length === 0) return
      const selectedPlate = this.plateLAbel.filter(function (plate) {
        return tags.includes(plate.name)
      })
      if (selectedPlate.length > 0) {
        const index = this.tagData.indexOf(selectedPlate[0].name)
        this.tagData.splice(index, 1)
      }
      const res = getCascaderObj(this.industryValue, this.plateLAbel)
      const name = res.join('/').trim()
      this.tagData.push(name)
      this.$emit('getData', this.tagData)
      this.industryValue = []
      this.$forceUpdate()
    },
    addIndustry (e) {
      if (this.industryValue.length === 0) return
      const res = getCascaderObj(this.industryValue, this.options)
      const name = res.join('/').trim()
      this.tagData.push(name)
      this.$emit('getData', this.tagData)
      this.industryValue = []
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss">
.input-tags {

  .button-new-tag {
    width: 100%;
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .el-tag {
    margin: 10px 10px 0 0;
  }

  .input-new-tag {
    width: 100% !important;
    // margin-left: 10px;
    vertical-align: bottom;
  }

  .button-new-tag {
    margin: 0;
  }

  .industry-label {
    width: calc(100% + 40px);
    margin-left: -40px;

    .label {
      white-space: nowrap;
      color: #606266;
    }
    .label.box{
      margin-left:5px
    }
    .label-select {
      margin-left: 12px;
      // width: 477.66px;
      // width: calc(100%);
      width: 100%;
    }
  }
}

</style>
